import { render } from "./AnnotationForm.vue?vue&type=template&id=65348f48&scoped=true"
import script from "./AnnotationForm.vue?vue&type=script&lang=js"
export * from "./AnnotationForm.vue?vue&type=script&lang=js"

import "./AnnotationForm.vue?vue&type=style&index=0&id=65348f48&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65348f48"]])

export default __exports__